module.exports = __webpack_public_path__ + "img/7_158.824e0f0b.png";